import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { restoreSessionOnResumeThunk } from '../../redux/thunk/session'

export const useSessionResume = (isEnabled) => {
	const dispatch = useDispatch()

	useEffect(() => {
		if (!isEnabled) {
			return
		}

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				dispatch(restoreSessionOnResumeThunk())
			}
		}

		document.addEventListener('visibilitychange', handleVisibilityChange)

		return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
	}, [isEnabled, dispatch])
}
